import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageNotRole from "../../../shared/Ui/PageNotFound/PageNotRole";
import { useAppSelector } from "../../../shared/hook";

/** refDocType агрегации — согласовать с бэком при необходимости */
export const AGGREGATION_DOC_TYPE = 7;

/** Редирект: /new → /new/orders, /:id → /:id/orders. Создание черновика — только на Orders. */
function DocumentAggregation() {
  const navigate = useNavigate();
  const { aggregationDocumentId } = useParams();
  const roleMatrix = useAppSelector((state) => state.roleMatrix);

  const canView =
    roleMatrix?.roleMatrix?.some(
      (item: any) =>
        (item.id === 5 || item.id === 6 || item.id === 12) && item.view,
    ) ?? true;

  useEffect(() => {
    if (!canView) return;
    if (!aggregationDocumentId || aggregationDocumentId === "new") {
      navigate("/documents/aggregation/new/orders", { replace: true });
      return;
    }
    navigate(`/documents/aggregation/${aggregationDocumentId}/orders`, {
      replace: true,
    });
  }, [aggregationDocumentId, canView, navigate]);

  if (!canView) return <PageNotRole />;
  return null;
}

export default DocumentAggregation;
